import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.aFyu8N',
    defaultMessage: 'Translations',
  },
  submit: {
    id: 'studio.jvo0vs',
    defaultMessage: 'Save',
  },
  selectedLanguage: {
    id: 'studio.szQT/W',
    defaultMessage: 'Selected language',
  },
  messages: {
    id: 'studio.hMzcSq',
    defaultMessage: 'Messages',
  },
  addLanguageTitle: {
    id: 'studio.S3s35A',
    defaultMessage: 'Add new language',
  },
  addLanguage: {
    id: 'studio.sIP2Kq',
    defaultMessage: 'Would you like to add a new language?',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  add: {
    id: 'studio.2/2yg+',
    defaultMessage: 'Add',
  },
  addSuccess: {
    id: 'studio.LyjWxx',
    defaultMessage: 'Successfully added language',
  },
  uploadError: {
    id: 'studio.J+5t/+',
    defaultMessage: 'Something went wrong when trying to upload messages for this language.',
  },
  addError: {
    id: 'studio.+JYDRp',
    defaultMessage: 'Something went wrong when trying to add this language.',
  },
  deleteTitle: {
    id: 'studio.pLERft',
    defaultMessage: 'Deleting translations for {language}',
  },
  deleteBody: {
    id: 'studio.LUfFLk',
    defaultMessage:
      'Are you sure you wish to delete the translations for this language? These can not be restored.',
  },
  delete: {
    id: 'studio.K3r6DQ',
    defaultMessage: 'Delete',
  },
  deleteError: {
    id: 'studio.Cet1wL',
    defaultMessage:
      'Something went wrong when trying to delete the translations for this language.',
  },
  language: {
    id: 'studio.y1Z3or',
    defaultMessage: 'Language',
  },
  deleteSuccess: {
    id: 'studio.xTZrx0',
    defaultMessage: 'Successfully deleted messages',
  },
  export: {
    id: 'studio.MHyPpu',
    defaultMessage: 'Export as JSON',
  },
  exportAll: {
    id: 'studio.4I6271',
    defaultMessage: 'Export all Messages',
  },
  import: {
    id: 'studio.4qv+fW',
    defaultMessage: 'Import from JSON file',
  },
  importSuccess: {
    id: 'studio.2rkKvL',
    defaultMessage: 'Successfully imported {selectedLanguage} translations',
  },
  importError: {
    id: 'studio.U1cf2h',
    defaultMessage: 'Something went wrong when reading the file.',
  },
  errorMessage: {
    id: 'studio.ql9rKu',
    defaultMessage: 'Error loading app messages',
  },
  loadingMessage: {
    id: 'studio.Ft/dkd',
    defaultMessage: 'Loading app messages',
  },
  overrideWarningLanguage: {
    id: 'studio.s3s2y0',
    defaultMessage: 'This will override all the messages for {language}',
  },
  overrideWarningAll: {
    id: 'studio.a8m+6u',
    defaultMessage: 'This will override messages for all languages found in the file.',
  },
});
